
















import { computed, defineComponent } from '@vue/composition-api';

import useDriverProfile from '@/useDriverProfile';

const AvailableVehicleDisplay = defineComponent({
  props: {
    vehicle: { type: Number, required: true },
  },
  setup(props) {
    const { integerToArray } = useDriverProfile();
    const vehicleArray = computed(() => integerToArray(props.vehicle));
    return { vehicleArray };
  },
});

export default AvailableVehicleDisplay;
